import React from 'react'

import Layout from '../components/Layout'
import Text from '../components/Text'
import Button from '../components/Button'
import ActionBar from '../components/ActionBar'
import BackButton from '../components/BackButton'

const Symptoms = ({ symptoms, onSetSymptoms, onNext, onBack }) => {
  const onSelectSymptom = symptom => {
    onSetSymptoms({
      ...symptoms,
      ...symptom
    })
  }

  const onSelect = symptom => {
    if (symptoms[symptom]) {
      return onSelectSymptom({
        [symptom]: undefined
      })
    }

    onSelectSymptom({
      [symptom]: true
    })
  }

  const renderPhase = () => {
    if (symptoms.cough === undefined) {
      return (
        <Layout key="cough">
          <Layout>
            <Text large>Have you had a persistent dry cough in the past 24 hours?</Text>
          </Layout>

          <Layout>
            <Button onClick={() => onSelectSymptom({ cough: true })} fullWidth>
              Yes
            </Button>

            <Button onClick={() => onSelectSymptom({ cough: false })} fullWidth>
              No
            </Button>
          </Layout>
        </Layout>
      )
    }

    if (symptoms.outOfBreath === undefined) {
      return (
        <Layout fade key="contact">
          <Layout>
            <Text large>Do you feel that you get out of breath easier than usually?</Text>
          </Layout>

          <Layout>
            <Button onClick={() => onSelectSymptom({ outOfBreath: true })} fullWidth>
              Yes
            </Button>

            <Button onClick={() => onSelectSymptom({ outOfBreath: false })} fullWidth>
              No
            </Button>
          </Layout>
        </Layout>
      )
    }

    return (
      <Layout fade key="symptoms">
        <Layout>
          <Text large>Please select if you have any of these symptoms</Text>
        </Layout>

        <Layout>
          <Button
            onClick={() => onSelect('fever')}
            selected={symptoms.fever}
            fullWidth
          >
            Fever
          </Button>

          <Button
            onClick={() => onSelect('fatigue')}
            selected={symptoms.fatigue}
            fullWidth
          >
            Feeling tired or weak
          </Button>

          <Button
            onClick={() => onSelect('diarrhea')}
            selected={symptoms.diarrhea}
            fullWidth
          >
            Diarrhea
          </Button>

          <Button
            onClick={() => onSelect('headache')}
            selected={symptoms.headache}
            fullWidth
          >
            Headache
          </Button>


          <Button
            onClick={() => onSelect('lossOfTasteSmell')}
            selected={symptoms.lossOfTasteSmell}
            fullWidth
          >
            Loss of taste and/or smell
          </Button>
        </Layout>
      </Layout>
    )
  }

  console.log(symptoms)

  return (
    <>
      {renderPhase()}

      <ActionBar active={symptoms}>
        <BackButton onClick={onBack} />
        <Button onClick={onNext} disabled={symptoms.outOfBreath === undefined}>
          Next
        </Button>
      </ActionBar>
    </>
  )
}

export default Symptoms
